// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__22rBy","bigColWidth":"Table_bigColWidth__66BBt","biggerColWidth":"Table_biggerColWidth__2u5s3","row":"Table_row__p5UlD","col":"Table_col__3tboX"};